import Modal from "common/components/Modal/Modal"
import NativePDFViewer from "common/components/NativePDF/NativePDF"

const ModalShowPdf = ({
  pdf,
  visible,
  onHide,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pdf: $TSMigrationFixMe
  visible: boolean
  onHide: () => void
}) => {
  return (
    <Modal
      header='PDF'
      size='normal'
      maskClassName='!tw-z-50'
      onHide={onHide}
      visible={visible}
      draggable
    >
      <div className='tw-w-full tw-h-full'>
        <NativePDFViewer
          pdf={pdf}
          type='stream'
          height='500px'
        />
      </div>
    </Modal>
  )
}

export default ModalShowPdf
